import { render } from "./HelpVideoListItem.vue?vue&type=template&id=26ef1244"
import script from "./HelpVideoListItem.vue?vue&type=script&lang=js"
export * from "./HelpVideoListItem.vue?vue&type=script&lang=js"
script.render = render

export default script

/* vue-cli-plugin-import-components */
import BaseIcon from "@/components/BaseIcon.vue";
import BaseConfirmModal from "@/components/BaseConfirmModal.vue";
script.components = Object.assign({}, { BaseIcon, BaseConfirmModal }, script.components);